export default __webpack_public_path__ + "static/seedling-9185038863febd4a28c58b3bbeba7357.png";